// extracted by mini-css-extract-plugin
module.exports = {"root":"WishlistButton_root__hMslP","rotation":"WishlistButton_rotation__7kPoi"};